import Api from 'api';

import {
  GET_PROJECTS,
  SET_PROJECTS_PAGINATION,
  SET_PROJECTS_FILTERS,
  RESET_PROJECTS,
  TOGGLE_PROJECT,
  ADD_PROJECT,
  UPDATE_PROJECT,
  GET_PROJECT_BY_ID,
  RESET_PROJECT_FORM,
  MODIFY_CUSTOM_FIELD_EDITING_PROJECT, //Groups
  MODIFY_EDITING_PROJECT,
} from 'projects/constants';

export const setPagination = (payload) => ({
  type: SET_PROJECTS_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_PROJECTS_FILTERS,
  payload,
});

export const getProjects = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_PROJECTS,
  payload: Api.projects.get(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const reset = () => ({ type: RESET_PROJECTS });

export const toggleProject = (projectId, companyId, subcompanyId) => ({
  type: TOGGLE_PROJECT,
  meta: { id: projectId },
  payload: Api.projects.toggle(projectId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_PROJECT_FORM });

export const getProjectById = (projectId, companyId, subcompanyId) => ({
  type: GET_PROJECT_BY_ID,
  meta: { needAuth: true },
  payload: Api.projects.getById(projectId, companyId, subcompanyId),
});

export const modifyProject = (payload) => ({ type: MODIFY_EDITING_PROJECT, payload });

//Groups
export const modifyCustomField = (payload) => ({
  type: MODIFY_CUSTOM_FIELD_EDITING_PROJECT,
  payload,
}); // Agregado

export const addProject = (companyId, subcompanyId, project) => ({
  type: ADD_PROJECT,
  payload: Api.projects.add(companyId, subcompanyId, project),
});

export const updateProject = (projectId, companyId, subcompanyId, project) => ({
  type: UPDATE_PROJECT,
  meta: { id: projectId, needAuth: true },
  payload: Api.projects.update(projectId, companyId, subcompanyId, project),
});



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/actions/projects_actions.js